/**
 * The photographer set-password link's limits (.server/provider-password-link.ts),
 * here so the link page's component can show them (a route's default export may
 * not import .server).
 */
export const PASSWORD_LINK_TTL_DAYS = 7;

/** The shortest password the link page accepts. */
export const PASSWORD_MIN_LENGTH = 8;

/** "Forgot password": the same answer whether or not there is an account, so it never says which addresses have one. */
export const FORGOT_SENT_MESSAGE =
  'If there is an account with that email address, we have emailed it a link to reset the password.';

/** "Forgot password" over its limit (.server/password-reset-throttle.ts): counted for every address, account or not. */
export const FORGOT_LIMITED_MESSAGE = 'Too many requests. Please wait a while and try again.';
